import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { aq as isNumber, a as getBody, g as getDocument, a7 as KeyboardCode } from './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { j as debounce, a as ComponentUtils } from './p-de830ba7.js';
const splitScreenCss = ".sc-owc-split-screen-h{display:-ms-flexbox;display:flex;min-width:100%;width:100%;height:100%;outline:none}.sc-owc-split-screen-h [slot=primary].sc-owc-split-screen{overflow:auto;-ms-flex:1 1 auto;flex:1 1 auto;height:100%}@supports (overflow: overlay){.sc-owc-split-screen-h [slot=primary].sc-owc-split-screen{overflow:overlay}}.sc-owc-split-screen-h [slot=secondary].sc-owc-split-screen{-ms-flex:1 1 auto;flex:1 1 auto;height:100%}.sc-owc-split-screen-h [slot=secondary].sc-owc-split-screen [slot=primary].sc-owc-split-screen{overflow:auto}@supports (overflow: overlay){.sc-owc-split-screen-h [slot=secondary].sc-owc-split-screen [slot=primary].sc-owc-split-screen{overflow:overlay}}.sc-owc-split-screen-h .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{font-size:var(--one-spacing-size-2-xs);color:var(--one-color-interaction-default-base)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;cursor:-webkit-grab;cursor:grab;width:var(--one-spacing-size-2-xs);min-width:var(--one-spacing-size-2-xs);min-height:100%;border-radius:var(--one-spacing-radius-5-xs);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;background-color:var(--one-color-interaction-default-intensity-low);color:var(--one-color-interaction-default-intensity-low)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:active{background-color:var(--one-color-interaction-hover-brand-lower);color:var(--one-color-interaction-hover-brand-lower)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:active .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:var(--one-color-interaction-hover-intensity-medium)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-active.sc-owc-split-screen{background-color:var(--one-color-interaction-hover-brand-lower);color:var(--one-color-interaction-hover-brand-lower)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-active.sc-owc-split-screen .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:var(--one-color-interaction-hover-intensity-medium)}@media (hover: hover){.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:hover{background-color:var(--one-color-interaction-hover-brand-lower);color:var(--one-color-interaction-hover-brand-lower)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:hover .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:var(--one-color-interaction-hover-intensity-medium)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-hover.sc-owc-split-screen{background-color:var(--one-color-interaction-hover-brand-lower);color:var(--one-color-interaction-hover-brand-lower)}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-hover.sc-owc-split-screen .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:var(--one-color-interaction-hover-intensity-medium)}}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:focus-visible{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);isolation:isolate}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-focus.sc-owc-split-screen{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);isolation:isolate}@supports not selector(:focus-visible){.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:focus{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);isolation:isolate}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:focus-within{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);isolation:isolate}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-focus.sc-owc-split-screen{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);isolation:isolate}}.owc-split-screen--direction-vertical.sc-owc-split-screen-h{-ms-flex-direction:column;flex-direction:column}.owc-split-screen--direction-vertical.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen{height:var(--one-spacing-size-2-xs);min-height:var(--one-spacing-size-2-xs);min-width:100%}.owc-split-screen--direction-vertical.sc-owc-split-screen-h .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.owc-split-screen--hide-primary.sc-owc-split-screen-h [slot=primary].sc-owc-split-screen{display:none !important}.owc-split-screen--hide-secondary.sc-owc-split-screen-h [slot=secondary].sc-owc-split-screen{display:none !important}.owc-split-screen--disabled.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen{cursor:default;pointer-events:none;background-color:var(--one-color-interaction-disabled-intensity-lower)}.owc-split-screen--disabled.sc-owc-split-screen-h .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:var(--one-color-interaction-disabled-base)}@media (forced-colors: active){.sc-owc-split-screen-h .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:buttontext}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen{border:var(--one-spacing-outline-regular) solid buttontext;width:calc(var(--one-spacing-size-2-xs) - 2 * var(--one-spacing-outline-regular));min-width:calc(var(--one-spacing-size-2-xs) - 2 * var(--one-spacing-outline-regular))}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:active{color:buttontext}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:active .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:buttontext}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-active.sc-owc-split-screen{color:buttontext}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-active.sc-owc-split-screen .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:buttontext}}@media (forced-colors: active) and (hover: hover){.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:hover .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:buttontext}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-hover.sc-owc-split-screen .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:buttontext}}@media (forced-colors: active){.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:focus-visible{outline-color:highlight}}@media (forced-colors: active){.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-focus.sc-owc-split-screen{outline-color:highlight}}@media (forced-colors: active){@supports not selector(:focus-visible){.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:focus{outline-color:highlight}.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen:focus-within{outline-color:highlight}.sc-owc-split-screen-h .owc-split-screen__resizer-container.owc-soft-focus.sc-owc-split-screen{outline-color:highlight}}}@media (forced-colors: active){.owc-split-screen--disabled.sc-owc-split-screen-h .owc-split-screen__resizer-container.sc-owc-split-screen{border-color:graytext}.owc-split-screen--disabled.sc-owc-split-screen-h .owc-split-screen__resizer-container__resizer-icon.sc-owc-split-screen{color:graytext}}";
const OwcSplitScreenStyle0 = splitScreenCss;
const DEFAULT_SIZE = 50;
const RESIZER_SIZE = 16;
const MAX_SIZE = 100;
const STEP_SIZE = 10;
const DEBOUNCE_TIMEOUT = 10;
const SIZING_THRESHOLD = 1;
const SplitScreen = /*@__PURE__*/proxyCustomElement(class SplitScreen extends H {
  constructor() {
    super();
    this.__registerHost();
    this.sizeChange = createEvent(this, "sizeChange", 3);
    this.resizing = createEvent(this, "resizing", 3);
    this.resizerElementRef = useRef();
    this.initialMouseX = 0;
    this.initialMouseY = 0;
    this.primarySlotHeight = 0;
    this.primarySlotWidth = 0;
    this.newSize = this.size;
    this.emitResizing = () => this.resizing.emit(this.newSize);
    this.debouncedEmitResizing = debounce(this.emitResizing, DEBOUNCE_TIMEOUT);
    this.isVertical = () => this.direction === 'vertical';
    this.getLimitedSize = size => Math.max(0, Math.min(MAX_SIZE, isNumber(size) ? size : DEFAULT_SIZE));
    this.setElementSize = (element, style) => {
      style.width && (element === null || element === void 0 ? void 0 : element.style.setProperty('width', style.width));
      style.height && (element === null || element === void 0 ? void 0 : element.style.setProperty('height', style.height));
    };
    this.cleanUp = () => {
      var _a, _b, _c;
      (_a = getBody()) === null || _a === void 0 ? void 0 : _a.style.removeProperty('cursor');
      (_b = getDocument()) === null || _b === void 0 ? void 0 : _b.removeEventListener('mousemove', this.onMouseMove);
      (_c = getDocument()) === null || _c === void 0 ? void 0 : _c.removeEventListener('mouseup', this.onMouseUp);
    };
    this.onMouseDown = e => {
      var _a, _b, _c;
      // Get the current mouse position
      this.initialMouseX = e.clientX;
      this.initialMouseY = e.clientY;
      // Get primary slot element size
      if (this.primarySlotRef) {
        const rect = this.primarySlotRef.getBoundingClientRect();
        this.primarySlotHeight = rect.height;
        this.primarySlotWidth = rect.width;
      }
      this.newSize = this.size;
      // add event listeners to document to not lose event that out of component
      (_a = getDocument()) === null || _a === void 0 ? void 0 : _a.addEventListener('mousemove', this.onMouseMove);
      (_b = getDocument()) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseup', this.onMouseUp);
      (_c = getBody()) === null || _c === void 0 ? void 0 : _c.style.setProperty('cursor', 'grabbing');
    };
    this.onMouseMove = e => {
      // How far the mouse has been moved
      const dx = e.clientX - this.initialMouseX;
      const dy = e.clientY - this.initialMouseY;
      const hostRect = this.hostElement.getBoundingClientRect();
      if (this.isVertical()) {
        const heightPercentage = Math.round((this.primarySlotHeight + dy) * MAX_SIZE / (hostRect.height - RESIZER_SIZE));
        if (!(heightPercentage > MAX_SIZE || heightPercentage < 0)) {
          this.setElementSize(this.primarySlotRef, {
            height: `${heightPercentage}%`
          });
          this.setElementSize(this.secondarySlotRef, {
            height: `${MAX_SIZE - heightPercentage}%`
          });
        }
        this.hideSecondary = heightPercentage >= MAX_SIZE;
        this.hidePrimary = heightPercentage <= 0;
        const oldSize = this.newSize;
        this.newSize = this.getLimitedSize(heightPercentage);
        Math.abs(oldSize - this.newSize) >= SIZING_THRESHOLD && this.debouncedEmitResizing();
      } else {
        const widthPercentage = Math.round((this.primarySlotWidth + dx) * MAX_SIZE / (hostRect.width - RESIZER_SIZE));
        if (!(widthPercentage > MAX_SIZE || widthPercentage < 0)) {
          this.setElementSize(this.primarySlotRef, {
            width: `${widthPercentage}%`
          });
          this.setElementSize(this.secondarySlotRef, {
            width: `${MAX_SIZE - widthPercentage}%`
          });
        }
        this.hideSecondary = widthPercentage >= MAX_SIZE;
        this.hidePrimary = widthPercentage <= 0;
        const oldSize = this.newSize;
        this.newSize = this.getLimitedSize(widthPercentage);
        Math.abs(oldSize - this.newSize) >= SIZING_THRESHOLD && this.debouncedEmitResizing();
      }
    };
    this.onMouseUp = () => {
      this.cleanUp();
      this.size = this.newSize;
    };
    this.component = new ComponentUtils(this).withKeydownManagerLazy(() => this.resizerElementRef.current, {
      keydownHandlers: [{
        key: [KeyboardCode.ArrowLeft],
        handler: () => this.size = this.getLimitedSize(this.size - 1),
        disabled: () => this.direction !== 'horizontal',
        preventDefault: true
      }, {
        key: [KeyboardCode.ArrowRight],
        handler: () => this.size = this.getLimitedSize(this.size + 1),
        disabled: () => this.direction !== 'horizontal',
        preventDefault: true
      }, {
        key: [KeyboardCode.ArrowUp],
        handler: () => this.size = this.getLimitedSize(this.size - 1),
        disabled: () => this.direction !== 'vertical',
        preventDefault: true
      }, {
        key: [KeyboardCode.ArrowDown],
        handler: () => this.size = this.getLimitedSize(this.size + 1),
        disabled: () => this.direction !== 'vertical',
        preventDefault: true
      }, {
        key: [KeyboardCode.PageUp],
        handler: () => this.size = this.getLimitedSize(this.direction === 'vertical' ? this.size - STEP_SIZE : this.size + STEP_SIZE),
        preventDefault: true
      }, {
        key: [KeyboardCode.PageDown],
        handler: () => this.size = this.getLimitedSize(this.direction === 'vertical' ? this.size + STEP_SIZE : this.size - STEP_SIZE),
        preventDefault: true
      }, {
        key: [KeyboardCode.Home],
        handler: () => this.size = this.getLimitedSize(this.size - MAX_SIZE),
        preventDefault: true
      }, {
        key: [KeyboardCode.End],
        handler: () => this.size = this.getLimitedSize(this.size + MAX_SIZE),
        preventDefault: true
      }]
    });
    this.size = DEFAULT_SIZE;
    this.disabled = false;
    this.direction = 'horizontal';
    this.hostAriaLabel = undefined;
    this.hidePrimary = false;
    this.hideSecondary = false;
    this.primarySlotRef = undefined;
    this.secondarySlotRef = undefined;
  }
  onDirectionChanged() {
    this.onSizeChanged();
  }
  onSizeChanged(newValue) {
    const limitedSize = this.getLimitedSize(this.size);
    const primaryPercentage = `${limitedSize}%`;
    const secondaryPercentage = `${MAX_SIZE - limitedSize}%`;
    this.hideSecondary = this.size >= MAX_SIZE;
    this.hidePrimary = this.size <= 0;
    this.setElementSize(this.primarySlotRef, this.isVertical() ? {
      width: '100%',
      height: primaryPercentage
    } : {
      width: primaryPercentage,
      height: '100%'
    });
    this.setElementSize(this.secondarySlotRef, this.isVertical() ? {
      width: '100%',
      height: secondaryPercentage
    } : {
      width: secondaryPercentage,
      height: '100%'
    });
    isNumber(newValue) && this.sizeChange.emit(this.size);
  }
  componentDidLoad() {
    this.onSizeChanged();
  }
  disconnectedCallback() {
    this.cleanUp();
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      disabled: this.disabled || !this.primarySlotRef || !this.secondarySlotRef,
      [`direction-${this.direction || 'horizontal'}`]: true,
      'hide-primary': this.hidePrimary,
      'hide-secondary': this.hideSecondary
    });
    const resizerContainer = this.component.getChildBemClasses('resizer-container', hostClasses);
    const resizerIcon = this.component.getChildBemClasses('resizer-icon', resizerContainer);
    return h(Host, {
      key: '3d3307b014cfd66969e1ab62d0059cb3d9e96812',
      class: hostClasses
    }, h("slot", {
      key: 'fb8d6c4a99bb2f6a24b6d160854eefc5dc3b93ee',
      name: "primary",
      ref: el => this.primarySlotRef = el
    }), h("div", Object.assign({
      key: '8826ef08ceb3a8d80794351212d63bbfe2702de9',
      ref: this.resizerElementRef,
      class: resizerContainer,
      onMouseDown: this.onMouseDown,
      tabIndex: this.disabled ? -1 : this.component.getInitialTabIndex(0)
    }, accessibility({
      role: 'separator',
      aria: {
        valuetext: `${this.size}%`,
        orientation: this.direction === 'vertical' ? 'vertical' : 'horizontal',
        label: this.hostAriaLabel
      }
    })), h("div", {
      key: 'c81244b5d1f6446b533eb40817abd6dc7b8b0c59',
      class: resizerIcon
    }, "||")), h("slot", {
      key: 'e494b7b78efee3b927ec11f9c0af30185dd94937',
      name: "secondary",
      ref: el => this.secondarySlotRef = el
    }));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "direction": ["onDirectionChanged"],
      "size": ["onSizeChanged"]
    };
  }
  static get style() {
    return OwcSplitScreenStyle0;
  }
}, [6, "owc-split-screen", {
  "size": [1538],
  "disabled": [516],
  "direction": [513],
  "hostAriaLabel": [1537, "aria-label"],
  "hidePrimary": [32],
  "hideSecondary": [32],
  "primarySlotRef": [32],
  "secondarySlotRef": [32]
}, undefined, {
  "direction": ["onDirectionChanged"],
  "size": ["onSizeChanged"]
}]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-split-screen"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-split-screen":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, SplitScreen);
        }
        break;
    }
  });
}
const OwcSplitScreen = SplitScreen;
const defineCustomElement = defineCustomElement$1;
export { OwcSplitScreen, defineCustomElement };